<template>
  <div id="app">
    <router-view></router-view>
    <div v-if="isLittleDoctor" class="back-door-doctor" title="点击小箭头可折叠或收起小博士按钮">
      <span :class="foldBackDoor ? 'el-icon-arrow-left' : 'el-icon-arrow-right'" @click="foldBackDoor = !foldBackDoor"
        style="margin-right: 2px;"></span>
      <el-switch v-show="foldBackDoor === false" v-model="backDoor" active-text="小博士开" inactive-text="小博士关"
        @change="setLittleDoctor">
      </el-switch>
    </div>
    <div id="toTop" v-show="isShow" @click="toTop()"></div>
    <el-dialog title="温馨提示" :visible.sync="notSubjectVisible" width="360px" center>
      <p style="line-height: 1.5;">您的账号当前暂未绑定学科，可能导致您无法查看考试报告。详情请咨询管理员～</p>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="notSubjectVisible = false">
          我知道了
        </el-button>
      </span>
    </el-dialog>

    <!-- 过期无权限弹窗 -->
    <yue-no-permission :item="permissionItem"></yue-no-permission>
  </div>
</template>

<script>
import { magicApi } from '@/utils/magic'
import { reportApi } from '@/v2/utils/api'

let timer = null;
export default {
  name: "App",
  data () {
    return {
      isShow: false,
      backing: false,
      backDoor: false,
      foldBackDoor: false,
      notSubjectVisible: false, // 没有绑定学科的弹出是否显示
      permissionItem: {
        type: 'no-permission',
        visible: false
      },
    };
  },
  computed: {
    isLittleDoctor: function () {
      return (this.$store.getters.getUserInfo.productPermissionIds || []).indexOf('LittleDoctor') >= 0 || location.origin.indexOf('localhost') >= 0
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener("scroll", this.handleScroll);
    });
    // 挂载魔术贴，小博士
    window.setLittleDoctor = this.setLittleDoctor
  },
  methods: {
    setLittleDoctor: magicApi.setBackDoor,
    handleScroll () {
      if (this.backing) return;

      let elTop = document.documentElement.scrollTop || document.body.scrollTop;
      let cHeight =
        document.documentElement.clientHeight || document.body.clientHeight;

      this.isShow = elTop > cHeight / 2 ? true : false;
    },

    toTop () {
      clearInterval(timer);
      this.backing = true;

      timer = setInterval(_ => {
        let curHeight =
          document.documentElement.scrollTop || document.body.scrollTop;

        let speed = -curHeight / 4; // 随着高度减速
        speed = speed > 0 ? Math.ceil(speed) : Math.floor(speed);

        if (curHeight === 0) clearInterval(timer);

        document.documentElement.scrollTop = curHeight + speed;
        document.body.scrollTop = curHeight + speed; //谷歌

        this.backing = false;
      }, 25);
    },
    checkUserSubject: function () {
      const roles = this.$store.state.login.userInfo.roles
      if (roles && roles.length === 1) {
        this.notSubjectVisible = roles[0].roleName === '阅卷教师'
      }
      return this.notSubjectVisible
    },
    checkAndGenerateReport (examId, next) {
      this.$confirm('已修改成绩，需要手动重新生成报告，是否现在立即重新生成？', '提示').then(() => {
        reportApi.generateReport({ examId: examId }).then(resp => {
          if (resp.success) {
            this.$message.success('报告生成成功')
          } else {
            this.$message.warning('报告生成失败')
          }
        });
      }).finally(() => {
        if (next) { next(); }
      })
    },
    showPermissionDialog(type = 'no-permission') {
      this.permissionItem.type = type
      this.permissionItem.visible = true
    },
    getJumpParams (platform = 'region', params = {}) {
      // 获取跳转链接参数
      return {
        ...params,
        token: YJ_REGION_STORAGE.getItem('token'),
        loginPlatform: platform,
        isLittleDoctor: this.isLittleDoctor
      }
    },
    getOutLink (url) {
      // 本地开发环境，需要跳转本地的单校平台
      const host = location.origin.indexOf('localhost') >= 0 ? 'http://localhost:8080' : location.origin
      // 获取外部链接
      const query = this.getJumpParams()
      // 将query对象转换为查询字符串
      const queryString = Object.keys(query)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`)
      .join('&')
      return host + '/oauth?' + queryString + '&url=' + encodeURIComponent(url)
    }
  },
  watch: {
    '$store.state.backDoor': function (val) {
      this.backDoor = val
    }
  }
};
</script>

<style>
@import "../node_modules/yuejuan-ui/lib/yuejuan-ui.css";

#app {
  min-width: 1150px;
}

#toTop {
  z-index: 999;
  position: fixed;
  right: 5px;
  bottom: 65px;
  width: 50px;
  height: 50px;
  background: url(~images/back_top_top.png) no-repeat;
  box-shadow: 0 0 5px #eee;
  cursor: pointer;
  border-radius: 2px;
  opacity: 0.8;
}

#toTop:hover {
  opacity: 1;
  box-shadow: 0 1px 5px #ccc;
}

.back-door-doctor {
  position: fixed;
  left: 10px;
  bottom: 10px;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
  background-color: white;
  z-index: 10000;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue